import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { provideState } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'

import { SELECTIONS_FEATURE_TOKEN } from '@features/selections/constants/selections.constants'
import { selectionReducer } from '@features/selections/store/reducers/selections.reducer'
import { SelectionsEffects } from '@features/selections/store/effects/selections.effects'

export function provideSelections(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(SELECTIONS_FEATURE_TOKEN, selectionReducer),
    provideEffects([SelectionsEffects])
  ])
}
